// angular
import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Params } from '@angular/router';
// interface & enums
import { IBusiness, IBusinessResponse } from '../interfaces/business.interface';
import { ApiSearchTypesEnum } from '@app/core/shared/enums/api-search-types.enum';

@Injectable()
export class SuppliersService {
  // all suppliers
  public suppliersList = signal<IBusiness[]>([]);
  public allSuppliersCount = signal<number>(0);
  public isSuppliersLoading = signal<boolean>(false);

  // home suppliers
  public homeSuppliersList = signal<IBusiness[]>([]);
  public homeSuppliersCount = signal<number | null>(null);
  public isHomeSuppliersLoading = signal<boolean>(false);

  // dependencies
  private readonly _httpClient = inject(HttpClient);
  constructor() {}

  // get all suppliers

  public getAllSuppliers(params: Params) {
    // empty suppliersList on every new api call
    this.suppliersList.set([]);
    // set loading to true
    this.isSuppliersLoading.set(true);

    return this._httpClient
      .get<IBusinessResponse>(`main/businesses`, {
        params: {
          ...params,
          search_type: ApiSearchTypesEnum.Business,
        },
      })
      .subscribe({
        next: res => {
          // set suppliers data
          this.suppliersList.set(res.data);
          // set suppliers count
          this.allSuppliersCount.set(res.count);
        },
        error: () => this.isSuppliersLoading.set(false),
        complete: () => this.isSuppliersLoading.set(false),
      });
  }

  // get home suppliers
  public getHomeSuppliers() {
    // set loading to true
    this.isHomeSuppliersLoading.set(true);

    return this._httpClient
      .get<IBusinessResponse>(`main/businesses`, {
        params: {
          search_type: ApiSearchTypesEnum.Business,
          type: 'SUPPLIERS',
          take: 4,
        },
      })
      .subscribe({
        next: res => {
          // set suppliers data

          this.homeSuppliersList.set(res.data);

          // set suppliers count
          this.homeSuppliersCount.set(res.count);
        },
        error: () => this.isHomeSuppliersLoading.set(false),
        complete: () => this.isHomeSuppliersLoading.set(false),
      });
  }
}
